<template>
  <ContentPage back>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">Choose a Pro</div>
    </template>
    <Section class="px-10 py-8">
      <v-btn :disabled="disabled" color="primary" x-large class="justify-start" @click="autoPickClick">
        <div class="d-flex">
          <v-icon>mdi-bullseye-arrow</v-icon>
          <div class="ml-4 text-left">
              <div>Auto Select</div>
              <div style="font-size: 12px; text-transform: none">(Let the robot choose!)</div>
          </div>
        </div>
      </v-btn>

      <v-btn :disabled="disabled" @click="manualPickClick" x-large class="mt-6 justify-start">
        <div class="d-flex">
          <v-icon>mdi-account-wrench-outline</v-icon>
          <div class="ml-4 text-left">
              <div>Let me Choose</div>
              <div style="font-size: 12px; text-transform: none">(I want control!)</div>
          </div>
        </div>
      </v-btn>
    </Section>

    <ErrorOverlay
      title="No Pros Found." v-model="error_dialog"
      :loading="false"
    >
      {{ error_message }}
    </ErrorOverlay>
  </ContentPage>
</template>


<script>
import { ContentPage, ErrorOverlay, Section } from '@/components/pages'
import { mapGetters } from 'vuex'


export default {
  name: 'ReferralsChooseMethod',
  
  components: { ContentPage, ErrorOverlay, Section },

  data: () => ({
    disabled: false,

    // for error messages
    loading: false,
    error_dialog: false,
    error_message: '',
  }),

  computed: {
    ...mapGetters('referrals', {
      currentService: 'currentServiceID',
      currentRequest: 'currentRequest',
      allPros: 'allPros',
    }),
  },

  methods: {
    async autoPickClick() {
      this.disabled = true
        this.$router.push({ name: 'referrals/confirm', params: { automatic: true } })
    },

    manualPickClick() {
      this.$router.push({ name: 'referrals/pro' })
    },
  },

  created() {
    if (this.currentService == -1) {
      this.$router.replace({ name: 'referrals' })
    }
  }
}
</script>